export default __webpack_public_path__ + "static/media/Clan Bound Gloves of the Far Horizon.98ec1fdf.jpg";